import {
  TrendingUp,
  Workflow,
  Zap,
  ShieldCheck,
  RefreshCw,
  Award,
  Layers,
  UserCheck,
  FilterX,
  Headphones,
} from "lucide-react";

export const HERO_HIGHLIGHTS = [
  {
    icon: TrendingUp,
    title: "Leverage Buyer Information",
    subtitle: "Actionable intent telemetry across markets",
  },
  {
    icon: Workflow,
    title: "Connect, Engage, & Convert",
    subtitle: "Direct pathways to active corporate buyers",
  },
  {
    icon: Zap,
    title: "Higher Conversion Rate",
    subtitle: "Shortened sales velocity with verified leads",
  },
];

export const GUARANTEED_BENEFITS = [
  {
    id: "accuracy",
    badge: "Quality Benchmark",
    title: "85% Accuracy for Data Fields",
    icon: ShieldCheck,
    stat: "85%",
    statLabel: "Guaranteed Accuracy",
    description:
      "We understand the importance of data accuracy and we do our best to keep our database up-to-date. We carry out a multi-stage QA process supported by our various techniques to avoid anomalies in data consistency and accuracy. This cycle repeats every 45 days. While maintaining 100% accuracy is impractical as data such as email, physical addresses, and phone numbers are subject to change, we guarantee 85% overall accuracy percentage at all data points.",
    chips: ["Multi-Stage QA", "45-Day Refresh Cycle", "Anomaly Detection"],
  },
  {
    id: "bounces",
    badge: "Risk Mitigation",
    title: "Replacement in Case of Hard Bounces",
    icon: RefreshCw,
    stat: "100%",
    statLabel: "Replacement or Credits",
    description:
      "Every data point is meticulously verified and then re-verified to ensure you get the best of it. Data accuracy is paramount to successfully entering a new market or working within a familiar one. We bet on precision. However, in the unlikely event that hard bounces or inaccuracies exceed the guaranteed percentage, we offer a replacement effective immediately. If necessary, we even offer credits and/or refunds for inaccurate contacts.",
    chips: ["Immediate Replacement", "Credits & Refunds", "Sender Score Protection"],
  },
];

export const PROMISED_BENEFITS_LIST = [
  {
    icon: Layers,
    title: "Perpetual Use Rights",
    desc: "Contacts purchased are yours for perpetual use with no ongoing lock-ins.",
  },
  {
    icon: UserCheck,
    title: "Consent-Based Opt-In Contacts",
    desc: "Database strictly includes permission-based, compliant business opt-ins.",
  },
  {
    icon: FilterX,
    title: "Duplicate & Generic Free",
    desc: "Lists are completely cleansed of duplicate entries and generic role-based inboxes.",
  },
  {
    icon: Headphones,
    title: "24-Hour Customer Support",
    desc: "Round-the-clock technical and campaign assistance from dedicated data experts.",
  },
  {
    icon: Award,
    title: "360-Degree Database Solutions",
    desc: "Complete panoramic business intelligence to conserve valuable sales resources.",
  },
];

export const SAMPLE_DATA_POINTS = [
  "Contact Name",
  "Job Title",
  "Allowance Number",
  "Direct Business Email",
  "Website URL",
  "HQ & Branch Location",
  "Consumer Behavior Signals",
  "Buyer Intent Classification",
];